import { SNK } from '@/helpers/helpers'
import { getHistoryUrlParams } from '@/store/gamestate/gamestate'
import router from '@/router'
import { namespaces } from '@/helpers/constants'
import { getRouteNameByStudyTab } from '@/store/router/router'

const customSolutionCalls = {
  api_poker_player_ranges({ commit, dispatch, getters, rootGetters }, { namespace = 'solfigr' }) {
    const slfrm_shortcut = getters[`${namespace}/slfrm_shortcut`]
    const sshr = slfrm_shortcut
    const params = {
      depth: sshr.gameformat.depth,
      label_id: sshr.label_id,
      gametype: sshr.gameformat.gametype,
      stacks: sshr.gameformat.stacks,
    }

    dispatch('api_call', {
      endpoint: 'custom-solutions/spot_preset/',
      apiVersion: 'v4',
      mutation: 'api_poker_player_ranges',
      action: `${namespace}/slfrm_applyApiPreset`,
      actionArgs: { range_prefill: true },
      params,
    })
  },

  api_poker_player_ranges_spot(
    { commit, dispatch, getters, rootGetters },
    { tmpNamespace, namespace = 'tmp/primary', labelId },
  ) {
    // TODO:REPORTS TODO:CR_REPORTS #REFACTOR:NAMESPACES
    const pathName = getRouteNameByStudyTab(router, rootGetters)
    const solRepNamespace = rootGetters.user_has_flag('CR_REPORTS')
      ? {
          StudySolutions: namespaces.STUDY,
          StudyReports: namespaces.REPORTS,
        }[pathName]
      : ''

    const gameformat = getters[SNK('gameformat', tmpNamespace || solRepNamespace)]
    const hSpots = getters[SNK('history_spots', tmpNamespace || solRepNamespace)]

    const hp = getHistoryUrlParams({ history_spots: hSpots })

    const params = {
      depth: gameformat.depth,
      gametype: gameformat.gametype,
      stacks: gameformat.stacks,
      ...(labelId
        ? { label_id: labelId }
        : {
            preflop_actions: hp.preflop_actions || router.currentRoute.value.query.preflop_actions,
          }),

      // Error test
      // preflop_actions: hp.preflop_actions, // New tab will fail - reopen via pecil icon and ok
      // preflop_actions: 'R2.5-F-X', // Will fail
    }

    dispatch('api_call', {
      endpoint: 'custom-solutions/spot_preset/',
      apiVersion: 'v4',
      mutation: 'api_poker_player_ranges',
      action: `${namespace}/slfrm_applyApiPreset`,
      actionArgs: { range_prefill: true },
      params,
    })
  },

  api_poker_custom_solution_tree(
    { commit, dispatch, rootGetters },
    { id, action, actionArgs, namespace },
  ) {
    const endpoint = `custom-solutions/custom-trees/${id}/`
    dispatch('api_call', {
      method: 'GET',
      endpoint,
      // custom tree is always unique - we can cache
      apiVersion: 'v4',
      gwCacheId: endpoint,
      gwCacheAdd: true,
      ...(action ? { action } : {}),
      ...(actionArgs ? { actionArgs } : {}),
      mutationArgs: { namespace },
      mutation: 'api_poker_custom_solution_tree',
    })
  },
  async api_poker_custom_solution_tree_create(
    { commit, dispatch, getters },
    { data, action, actionArgs, namespace },
  ) {
    const endpoint = 'custom-solutions/custom-trees/'
    await dispatch('api_call', {
      method: 'POST',
      endpoint,
      apiVersion: 'v4',
      mutationArgs: { namespace },
      mutation: 'api_poker_custom_solution_tree',
      action,
      actionArgs,
      data,
      message: { type: 'error' },
    })
  },

  api_poker_custom_user_trees_set(
    { commit, dispatch, rootGetters },
    { method, data, id, action, actionArgs } = {},
  ) {
    // TODO - tst this ... should work after all
    if (method !== 'patch') {
      const endpoint = `custom-solutions/custom-trees/saved-trees/${id ? `${id}/` : ''}`
      dispatch('api_call', {
        method,
        endpoint,
        apiVersion: 'v4',
        mutation: 'api_poker_custom_user_trees',
        data,
        ...(action ? { action } : {}),
        ...(actionArgs ? { actionArgs } : {}),
      })
    } else {
      const endpoint = `poker/custom-solutions/custom-trees/saved-trees/${id ? `${id}/` : ''}`
      dispatch('api_call', {
        method,
        endpoint,
        mutation: 'api_poker_custom_user_trees',
        data,
        ...(action ? { action } : {}),
        ...(actionArgs ? { actionArgs } : {}),
      })
    }
  },

  api_poker_custom_user_trees(
    { commit, dispatch, rootGetters },
    { id, action = 'solfigr/slfrm_applyApiPreset', actionArgs = {} } = {},
  ) {
    const endpoint = `custom-solutions/custom-trees/saved-trees/${id}/`
    dispatch('api_call', {
      method: 'GET',
      apiVersion: 'v4',
      endpoint,
      mutation: 'api_poker_custom_user_trees',
      action,
      actionArgs,
    })
  },

  api_poker_custom_range_set(
    { commit, dispatch, rootGetters },
    { method, data, id, action, actionArgs } = {},
  ) {
    const endpoint = `poker/custom-solutions/custom-trees/saved-ranges/${id ? `${id}/` : ''}`
    dispatch('api_call', {
      method,
      endpoint,
      mutation: 'api_poker_custom_range',
      data,
      ...(action ? { action } : {}),
      ...(actionArgs ? { actionArgs } : {}),
      // message: { type: 'error' },
    })
  },
  api_poker_custom_user_solution_set(
    { commit, dispatch, rootGetters },
    { method, data, id, action, actionArgs, globalAction } = {},
  ) {
    const endpoint = `poker/custom-solutions/user-solutions/${id ? `${id}/` : ''}`

    dispatch('api_call', {
      method,
      endpoint,
      mutation: 'api_poker_custom_user_solution',
      data,
      ...(action ? { action } : {}),
      ...(actionArgs ? { actionArgs } : {}),
    })
  },
  async api_poker_custom_solution_create(
    { commit, dispatch, rootGetters },
    { action, actionArgs, data, message = { type: 'error' }, namespace },
  ) {
    const endpoint = `poker/custom-solutions/`
    const result = await dispatch('api_call', {
      method: 'post',
      endpoint,
      mutation: 'api_poker_custom_solution',
      mutationArgs: { namespace },
      data,
      ...(action ? { action } : {}),
      ...(actionArgs ? { actionArgs } : {}),
      ...(message ? { message } : {}),
    })
    return result
  },
  async api_poker_custom_solution(
    { commit, dispatch, rootGetters },
    { action, actionArgs, id, namespace },
  ) {
    const endpoint = `custom-solutions/${id}/`
    await dispatch('api_call', {
      method: 'get',
      endpoint,
      apiVersion: 'v4',
      mutationArgs: { namespace },
      mutation: 'api_poker_custom_solution',
      ...(action ? { action } : {}),
      ...(actionArgs ? { actionArgs } : {}),
    })
  },

  api_poker_custom_solution_history(
    { commit, dispatch, rootGetters },
    { action, actionArgs, params },
  ) {
    const endpoint = `poker/custom-solutions/history/`
    dispatch('api_call', {
      method: 'get',
      endpoint,
      mutation: 'api_poker_custom_solution_history',
      params,
      ...(action ? { action } : {}),
      ...(actionArgs ? { actionArgs } : {}),
    })
  },

  async api_poker_custom_solution_history_initial(
    { commit, dispatch, rootGetters },
    { afterAction, afterActionArgs } = {},
  ) {
    const endpoint = `poker/custom-solutions/history/`
    return dispatch('api_call', {
      method: 'get',
      endpoint,
      ...(afterAction ? { afterAction } : {}),
      ...(afterActionArgs ? { afterActionArgs } : {}),
      mutation: 'api_poker_custom_solution_history',
      params: { offset: 0, limit: 1 },
    })
  },
  async api_custom_reports_history_initial(
    { commit, dispatch, rootGetters },
    { afterAction, afterActionArgs } = {},
  ) {
    const endpoint = `aggregated-report/custom/history/`
    return dispatch('api_call', {
      method: 'get',
      apiVersion: 'v4',
      endpoint,
      ...(afterAction ? { afterAction } : {}),
      ...(afterActionArgs ? { afterActionArgs } : {}),
      mutation: 'api_custom_aggregated_report_table',
      params: { offset: 0, limit: 1 },
    })
  },

  // remove after survey
  async api_poker_custom_solution_table_initial_for_the_survey({ commit, dispatch, rootGetters }) {
    const endpoint = `poker/custom-solutions/`
    return dispatch('api_call', {
      method: 'get',
      endpoint,
      mutation: 'api_poker_custom_solution_table_initial_for_the_survey',
      params: { offset: 0, limit: 11, is_favorite: true },
    })
  },

  api_poker_tree_preview(
    { commit, dispatch, rootGetters },
    { action, actionArgs, data, namespace, message },
  ) {
    dispatch('api_call', {
      method: 'post',
      endpoint: 'custom-solutions/tree-preview/',
      apiVersion: 'v4',
      mutation: 'api_poker_tree_preview',
      data,
      mutationArgs: { namespace },
      hasCancel: true,
      ...(action ? { action } : {}),
      ...(actionArgs ? { actionArgs } : {}),
      ...(message ? { message } : {}),
    })
  },
}

export default customSolutionCalls
